import { Pueblo } from './../../models/pueblo.model';
import { MasInformacionPage } from './../mas-informacion/mas-informacion';
import { Component } from '@angular/core';
import {  NavController, NavParams, App } from 'ionic-angular';
import { BuscadorPage } from '../buscador/buscador';
import { VariablesGlobales } from '../../providers/variables-globales';

/**
 * Generated class for the PuebloInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pueblo-info',
  templateUrl: 'pueblo-info.html',
})
export class PuebloInfoPage {
  public pueblo:Pueblo;
  public descripcionCompleta:String;

  constructor(public navCtrl: NavController, public navParams: NavParams,private app: App, public global: VariablesGlobales,) {
    this.pueblo = navParams.data as Pueblo;
    this.descripcionCompleta = this.pueblo.descripcion;
    this.pueblo.descripcion = this.pueblo.descripcion.substring(0,200);
    console.log(navParams.data);
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad PuebloInfoPage');
  }
  goToMasInformacion(){
    let img =  this.pueblo.imagenDatos;
    let nombre = this.pueblo.nombre;
    let descripcion = this.descripcionCompleta;
    this.app.getRootNav().push(MasInformacionPage,{img, nombre,descripcion });
  }

}



// WEBPACK FOOTER //
// ./src/pages/pueblo-info/pueblo-info.ts